
import Vue  from 'vue'
import { SearchFacets } from '@/search/types'
import { FACET_QUERY_PREFIX } from '@/search/const'
import BaseImage from '@/common/components/BaseImage.vue'
import { getFacetsAllTypeDetail } from '@/common/components/facets/helper'
import { SYSTEM_ERROR, SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  name: 'FacetsLink',
  components: {
    BaseImage
  },
  props: {
    categoryId: {
      type: Number,
      default: undefined
    }
  },
  data(): {
    facetItems: SearchFacets[],
  } {
    return {
      facetItems: []
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.FACET_LINK_CARD
    },
    isMobileWidth(): boolean {
      return window.innerWidth < 1024
    },
    queryParams(): number[] {
      return this.categoryId ? [this.categoryId] : []
    },
    categorySuffix(): string {
      return this.categoryId ? `&category=${this.categoryId}` : ''
    }
  },
  async created() {
    const { data } = await getFacetsAllTypeDetail(this.queryParams, false).catch(()=> alert(SYSTEM_ERROR.UNKNOWN))
    if (data) this.facetItems = data?.productSearchResults?.facets
    if (this.categoryId) {
      const { data } = await getFacetsAllTypeDetail(this.queryParams, true).catch(()=> alert(SYSTEM_ERROR.UNKNOWN))
      if (data.productSearchResults?.facets) this.facetItems = this.facetItems.concat(data.productSearchResults?.facets)
    }
  },
  methods: {
    searchByFacets(facetKey: string, facetValue: string) {
      window.location.href = `/search?${FACET_QUERY_PREFIX}${facetKey}=${facetValue}${this.categorySuffix}`
    },
    numberDisplayedPerRowStyle(value: number | null, facetLength: number) {
      const numberPerRow = value ?? 5
      return {
        gridTemplateColumns: `repeat(${ this.isMobileWidth ? 3 : Math.min(numberPerRow, facetLength) }, 1fr)`
      }
    }
  }
})
